import type { Prompt } from "@/services/api.service";

export const GATEWAY_PROMPT_GROUPS = [
  { label: "Tutor", prefix: "notepad-tutor-" },
  { label: "Figure — diagram & edit", prefix: "notepad-figure-" },
  { label: "Verifier", prefix: "notepad-verify-" },
  { label: "Page OCR", prefix: "notepad-page-ocr-" },
];

// `known` must include hidden prompts: a TV may still pin one, and an id it lacks falls
// to the fallback app, which would save a gateway snapshot to the ai-tutor record.
export const promptAppId = (
  promptId: string,
  known: Pick<Prompt, "prompt_id" | "application_id">[],
  fallbackAppId: string,
) => known.find((p) => p.prompt_id === promptId)?.application_id || fallbackAppId;

export const partitionPromptsByApp = <T extends { prompt_id: string }>(
  snapshots: T[],
  known: Pick<Prompt, "prompt_id" | "application_id">[],
  applicationId: string,
) => {
  if (applicationId !== "ai-tutor") return { primary: snapshots, gateway: [] as T[] };
  const isGateway = (p: T) => promptAppId(p.prompt_id, known, applicationId) === "gateway";
  return { primary: snapshots.filter((p) => !isGateway(p)), gateway: snapshots.filter(isGateway) };
};

// The gateway reads notepad models from its own record, so they always go; prompts go only
// when that cannot empty a record that has some.
export const gatewayPromptsUpdate = <T>(siblingPromptCount: number, gatewayPrompts: T[]) =>
  gatewayPrompts.length > 0 || siblingPromptCount === 0 ? { prompts: gatewayPrompts } : {};
